import React, { Component } from 'react';
import { Table, ButtonToolbar, Button, Grid, Row, Col, Label, Form, FormGroup, InputGroup, FormControl, Modal } from 'react-bootstrap';

import { DataIdentifierOptionsFormatHelper } from '../helpers/DataIdentifierOptionsFormatHelper';
import { TableButton } from '../../TableButton';

class QrCodeOptionsDataIdentifier extends Component {
    render() {
        const { show, options } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>OPÇÕES PARA CONTEÚDO DO TEXTO</Modal.Header>
                <Modal.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>Opção</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map((option, idx) =>
                                    <tr className="selectable" key={`data-${idx}`}>
                                        <td onClick={() => this.props.onSelect(DataIdentifierOptionsFormatHelper.getOptionValue(option))}>
                                            {DataIdentifierOptionsFormatHelper.getOptionText(option)}
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <ButtonToolbar>
                        <Button onClick={this.props.onHide}>CANCELAR</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}

export class QrCodeDataIdentifier extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedData: this.props.selectedData,
            form: {
                content: undefined,
            },
            styles: {
                content: null,
            },
            contentOptions: {
                show: false,
                options: [
                    "lineCode",
                    "stopCode",
                ]
            }
        };
    }

    // -----------------------

    onSelectData() {
        const { selectedData } = this.state;

        this.props.onSelectData(selectedData, true);
    }

    onSaveData() {
        const { form } = this.state;

        const selectedData = form.content;
        form.content = undefined;

        this.setState({
            selectedData: selectedData,
            form: form
        });
    }

    // -----------------------

    onExitForm() {
        const { form } = this.state;

        form.content = undefined;

        this.setState({
            form: form
        });
    }

    onExitContentOptions() {
        const { contentOptions } = this.state;

        contentOptions.show = false;

        this.setState({
            contentOptions: contentOptions
        });
    }

    // -----------------------

    handleEditClick() {
        const { selectedData, form } = this.state;

        form.content = selectedData;

        this.setState({
            form: form
        });
    }

    handleOptionsClick() {
        const { contentOptions } = this.state;

        contentOptions.show = true;

        this.setState({
            contentOptions: contentOptions
        });
    }

    onSelectContentOption(value) {
        const { form } = this.state;

        form.content += value;

        this.setState({
            form: form
        }, () => {
            const textInput = document.getElementById("formDataContent");

            textInput.focus();
            textInput.setSelectionRange(form.content.length, form.content.length);
        });

        this.onExitContentOptions();
    }

    // -----------------------

    onChangeValue(e, target) {
        const { form } = this.state;
        form[target] = e.target.value;

        this.setState({
            form: form
        });
    }

    // -----------------------

    renderForm(form) {
        if (undefined === form.content) {
            return null;
        }

        const { styles } = this.state;

        return (
            <tr>
                <td>
                    <Form className="float-left">
                        <FormGroup bsSize="small"
                            controlId="formDataContent"
                            className="margin-bottom-0"
                            validationState={styles.content} >
                            <InputGroup bsSize="small">
                                <FormControl
                                    type="text"
                                    placeholder="Conteúdo"
                                    value={form.content}
                                    onChange={(e) => this.onChangeValue(e, 'content')} />

                                <InputGroup.Button>
                                    <Button onClick={() => this.handleOptionsClick()}>OPÇÕES</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                    </Form>
                </td>
                <td>
                    <Button bsStyle="default" className="float-right" onClick={() => this.onSaveData()}>GUARDAR</Button>
                </td>
            </tr>
        );
    }

    renderContent(options, content) {
        let contentToRender = [];
        let contentLabels = [];

        let tempContent = undefined === content || null === content ? "" : content;
        for (let i in options) {
            const option = DataIdentifierOptionsFormatHelper.getOptionValue(options[i]);
            const label = DataIdentifierOptionsFormatHelper.getOptionTextFromValue(option);

            let idx = 0;
            do {
                idx = tempContent.indexOf(option);
                if (-1 !== idx) {
                    tempContent = tempContent.replace(option, new Array(option.length + 1).join("-"));
                    contentLabels.push({ option: option, label: label, index: idx })
                }
            } while (-1 !== idx);
        }

        contentLabels = contentLabels.sort((a, b) => {
            if (a.index > b.index) return 1;
            if (b.index > a.index) return -1;
            return 0;
        });

        if (0 === contentLabels.length) {
            contentToRender.push(content);
        }
        else {
            let lastIndex = 0;
            for (let i in contentLabels) {
                contentToRender.push(content.substring(lastIndex, contentLabels[i].index));
                contentToRender.push(<Label key={`label-${i}`}>{contentLabels[i].label}</Label>);

                lastIndex = contentLabels[i].index + contentLabels[i].option.length;
            }
            contentToRender.push(content.substring(lastIndex));
        }

        return (
            <div>{contentToRender}</div>
        );
    }

    render() {
        const { selectedData, form, contentOptions } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Table responsive striped hover className="margin-top-10">
                                <thead>
                                    <tr>
                                        <th>Conteúdo</th>
                                        <th className="width-1p">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{this.renderContent(contentOptions.options, selectedData)}</td>
                                        <td><TableButton className="float-right" icon="icon-edit" title="Editar" onClick={() => this.handleEditClick()} /></td>
                                    </tr>
                                    {this.renderForm(form)}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onSelectData()}>GUARDAR ALTERAÇÕES</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <QrCodeOptionsDataIdentifier
                    options={contentOptions.options}
                    show={contentOptions.show}
                    onHide={() => this.onExitContentOptions()}
                    onSelect={(a) => this.onSelectContentOption(a)} />
            </div>
        );
    }
}
